type Props = {
  iconComponent: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  className?: string;
};

export function IconBox({ iconComponent: IconComponent, className }: Props) {
  return (
    <div className="inline-flex size-60 flex-shrink-0 items-center justify-center rounded-12 bg-blue-200">
      <IconComponent className={`size-36${className || ""}`} />
    </div>
  );
}
